/*
Replace
menuDishRecipeIngredient with your resource Name :) Take care about different writings!
/!\ DishRecipeIngredient menuDishRecipeIngredient DishRecipeIngredients menuDishRecipeIngredients /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
  defaultList,
  defaultListFail,
  defaultListSuccess,
  defaultShow,
  defaultShowFail,
  defaultShowSuccess,
  defaultUpdate,
  defaultUpdateSuccess,
  defaultUpdateFail,
  defaultCreate,
  defaultCreateSuccess,
  defaultCreateFail,
  defaultAddToDictionary,
} from "../defaultReducers";
import { defaultInitialState } from "../defaultInitialState";

export const menuDishRecipeIngredientSlice = createSlice({
  name: "menuDishRecipeIngredients",
  initialState: { ...defaultInitialState, stored: true },
  reducers: {
    list: defaultList,
    listSuccess: defaultListSuccess,
    listFail: defaultListFail,
    show: defaultShow,
    showSuccess: defaultShowSuccess,
    showFail: defaultShowFail,
    create: defaultCreate,
    createSuccess: defaultCreateSuccess,
    createFail: defaultCreateFail,
    update: defaultUpdate,
    updateSuccess: defaultUpdateSuccess,
    updateFail: defaultUpdateFail,
    addToDictionary: defaultAddToDictionary,
  },
});

export const {
  list: listDishRecipeIngredients,
  show: showDishRecipeIngredient,
  create: createDishRecipeIngredient,
  update: updateDishRecipeIngredient,
} = menuDishRecipeIngredientSlice.actions;

export const actions = menuDishRecipeIngredientSlice.actions;
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const menuDishRecipeIngredients = (state) =>
  state.menuDishRecipeIngredients.idsList.map(
    (id) => state.menuDishRecipeIngredients.dictionary[id]
  );

export const getMenuDishRecipeIngredient = createSelector(
  [
    (state) => state.menuDishRecipeIngredients.dictionary,
    (_, dishRecipeIngredientId) => dishRecipeIngredientId,
    (_, _dishRecipeIngredientId, menuDishId) => menuDishId,
  ],
  (dictionary, dishRecipeIngredientId, menuDishId) => {
    return Object.entries(dictionary).find(
      (_menuDishRecipeIngredient) =>
        _menuDishRecipeIngredient[1].attributes.menu_dish_id === menuDishId &&
        _menuDishRecipeIngredient[1].attributes.dish_recipe_ingredient_id ===
          dishRecipeIngredientId
    )?.[1];
  }
);

export default menuDishRecipeIngredientSlice.reducer;
